import $ from 'jquery';

/**
 *
 */
export function modalUtils() {
  $('.modal').each(function() {
    $(this).insertAfter('.site-wrapper');
  });
}
